// Mock data for Healthpreneur Leadership Programme Landing Page

export const programData = {
  name: "Healthpreneur Leadership Programme",
  subtitle: "Post Graduate Diploma in Nutrition with International Certification",
  tagline: "Transform Your Passion for Wellness Into a Thriving Authority-Based Business",
  seatsAvailable: 60,
  duration: "12 Months",
  
  hero: {
    title: "Become a Certified Wellness Industry Leader",
    subtitle: "Post Graduate Diploma in Nutrition with International Certification",
    description: "A one-year, industry-integrated leadership and career development programme. Limited to 60 students. Selection-based admission with merit scholarships available.",
    ctaText: "Apply Now",
    ctaSubtext: "Selection-based admission • Only 60 seats available • Merit scholarships for qualifying candidates",
    backgroundImage: "https://images.pexels.com/photos/15391542/pexels-photo-15391542.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },

  highlights: [
    {
      icon: "Award",
      title: "International Certification",
      description: "Post Graduate Diploma in Nutrition with globally recognized certification"
    },
    {
      icon: "TrendingUp",
      title: "Learn While You Earn",
      description: "Performance-based stipends and incentives during your training"
    },
    {
      icon: "Users",
      title: "Limited to 60 Seats",
      description: "Personalized mentoring with limited intake for quality education"
    },
    {
      icon: "Briefcase",
      title: "Career Support",
      description: "Placement support and entrepreneurship mentorship throughout"
    }
  ],

  programPillars: [
    {
      title: "Authority Building",
      description: "Establish yourself as a thought leader in the wellness space with proven positioning strategies, content frameworks, and media presence techniques.",
      image: "https://images.unsplash.com/photo-1765020553734-2c050ddb9494?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMG1lbnRvcnxlbnwwfHx8fDE3NzUzMzI5MjV8MA&ixlib=rb-4.1.0&q=85",
      outcomes: [
        "Personal brand positioning strategy",
        "Content creation and distribution",
        "Media and speaking opportunities",
        "Industry recognition pathway"
      ]
    },
    {
      title: "Business & Entrepreneurship Skills",
      description: "Master the complete business lifecycle from startup to scale with practical frameworks in sales, marketing, and operations specific to wellness industry.",
      image: "https://images.unsplash.com/photo-1758611973045-7a3e0470a2bc",
      outcomes: [
        "Business model development",
        "Revenue generation strategies",
        "Marketing and sales mastery",
        "Operations and automation"
      ]
    },
    {
      title: "Client Psychology & Handling",
      description: "Deep dive into behavioral psychology, transformation frameworks, and coaching methodologies that create lasting client results and referrals.",
      image: "https://images.unsplash.com/photo-1560070201-d3d11effa179",
      outcomes: [
        "Client psychology fundamentals",
        "Transformation methodology",
        "Communication mastery",
        "Retention and referral systems"
      ]
    },
    {
      title: "International Certification",
      description: "Earn globally recognized credentials from accreditation bodies with 40+ years of industry leadership, opening doors worldwide.",
      image: "https://images.unsplash.com/photo-1589330694653-ded6df03f754",
      outcomes: [
        "Internationally accredited certification",
        "Professional designation",
        "Global practice rights",
        "Continuing education credits"
      ]
    }
  ],

  benefits: [
    {
      icon: "Trophy",
      title: "Pioneer Industry Credentials",
      description: "Certification from bodies with 25+ years of pioneering excellence in wellness education"
    },
    {
      icon: "Lightbulb",
      title: "Complete Skill Transformation",
      description: "Master sales, marketing, communication, and entrepreneurship in one integrated journey"
    },
    {
      icon: "DollarSign",
      title: "Earn While You Learn",
      description: "Start client work from month 3 and generate revenue while completing the program"
    },
    {
      icon: "LineChart",
      title: "Authority Positioning",
      description: "Build your personal brand as a recognized wellness industry leader and expert"
    },
    {
      icon: "Users2",
      title: "Client Psychology Mastery",
      description: "Deep understanding of behavioral change, client handling, and transformation delivery"
    },
    {
      icon: "Globe",
      title: "Global Network Access",
      description: "Join an exclusive community of 60 ambitious wellness entrepreneurs worldwide"
    }
  ],

  curriculum: {
    phases: [
      {
        month: "Months 1-3",
        title: "Foundation & Identity",
        focus: "Certification fundamentals, personal brand foundation, market positioning",
        modules: [
          "Wellness industry landscape and opportunities",
          "Personal brand identity and positioning",
          "Certification module 1: Core principles",
          "Initial client acquisition strategy"
        ]
      },
      {
        month: "Months 4-6",
        title: "Skills & Authority",
        focus: "Advanced skills, authority building, content strategy, first clients",
        modules: [
          "Sales and marketing fundamentals",
          "Content creation and distribution",
          "Certification module 2: Advanced practice",
          "Client psychology and behavior change"
        ]
      },
      {
        month: "Months 7-9",
        title: "Business & Scale",
        focus: "Business development, revenue optimization, systems building",
        modules: [
          "Business model and revenue streams",
          "Operations and automation",
          "Certification module 3: Mastery level",
          "Team building and delegation"
        ]
      },
      {
        month: "Months 10-12",
        title: "Leadership & Legacy",
        focus: "Industry leadership, scaling strategies, certification completion",
        modules: [
          "Thought leadership and media presence",
          "Advanced client transformation",
          "Final certification and designation",
          "Long-term growth and impact strategy"
        ]
      }
    ]
  },

  testimonials: [
    {
      name: "Priya Sharma",
      role: "Certified Wellness Coach & Business Owner",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400",
      quote: "This program didn't just give me a certification—it transformed my entire identity. Within 6 months, I was earning more than my corporate salary while building something meaningful.",
      results: "From corporate employee to 6-figure wellness business owner"
    },
    {
      name: "Rahul Mehta",
      role: "Holistic Health Authority",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
      quote: "The international accreditation opened doors globally, but the business and psychology training is what actually made me successful. I now have a waitlist of clients.",
      results: "Built a waitlist practice in 4 months"
    },
    {
      name: "Anjali Desai",
      role: "Health Entrepreneur & Speaker",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400",
      quote: "The 'earn while you learn' model was game-changing. I started with clients in month 3 and by graduation, I had a thriving practice and was speaking at industry events.",
      results: "From zero to industry speaker in 12 months"
    }
  ],

  investmentOptions: [
    {
      name: "Test Payment",
      price: "₹1",
      originalPrice: null,
      features: [
        "Test payment for demo purposes",
        "Complete payment flow testing",
        "Verify Razorpay integration",
        "For testing only - not actual enrollment"
      ],
      badge: "Test",
      ctaText: "Test Payment",
      paymentType: "test",
      amount: 1,
      isTest: true
    },
    {
      name: "Standard Payment",
      price: "₹60,000",
      originalPrice: null,
      features: [
        "12-month comprehensive curriculum",
        "International certification",
        "Live mentorship sessions",
        "Course materials and resources",
        "Community access",
        "Nutritional counselling from month 3",
        "3-year placement support",
        "One-time payment (best value)"
      ],
      badge: null,
      ctaText: "Enroll Now",
      paymentType: "standard",
      amount: 60000
    },
    {
      name: "Flexible Installments",
      price: "₹18,000 × 4",
      originalPrice: null,
      totalPrice: "₹72,000",
      features: [
        "Everything in Standard Payment",
        "Pay in 4 easy installments",
        "₹18,000 per installment",
        "Flexible payment schedule",
        "No hidden charges"
      ],
      badge: "Flexible",
      ctaText: "Choose Installments",
      popular: false,
      paymentType: "installment",
      amount: 18000,
      totalAmount: 72000,
      installments: 4
    },
    {
      name: "100% Scholarship",
      price: "₹60,000",
      originalPrice: null,
      features: [
        "Pay ₹60,000 upfront",
        "100% refund at course completion",
        "For students with 85%+ marks",
        "Theory + Practical assessment",
        "All Standard Payment benefits",
        "Performance-based refund",
        "Surveys and field work evaluation",
        "Client consultation assessment"
      ],
      badge: "Refundable",
      ctaText: "Apply for Scholarship",
      popular: true,
      paymentType: "scholarship",
      amount: 60000,
      isRefundable: true
    }
  ],

  faqs: [
    {
      question: "What makes this program different from other wellness certifications?",
      answer: "Unlike traditional certification programs that focus only on wellness knowledge, our integrated approach combines international certification with complete business education, authority building, and practical client work. You graduate not just certified, but with a running business and established market presence."
    },
    {
      question: "How does the 'earn while you learn' model work?",
      answer: "From month 3 onwards, you'll start working with real clients under mentorship guidance. We provide client acquisition frameworks, done-with-you templates, and ongoing support so you can generate revenue while completing your certification. Many students cover their program investment before graduation."
    },
    {
      question: "What are the selection criteria for admission?",
      answer: "We look for commitment, coachability, and genuine passion for the wellness industry. The selection process includes an application review, one-on-one interview, and assessment of your goals and readiness. Prior wellness background is helpful but not mandatory—we've successfully trained career changers from various fields."
    },
    {
      question: "Is the international certification recognized globally?",
      answer: "Yes. Our certifying bodies have been pioneering wellness education for over 40 years and are recognized across major markets including USA, UK, Canada, Australia, and throughout Asia and Europe. You'll have the credentials to practice internationally."
    },
    {
      question: "What if I can't attend live sessions due to my schedule?",
      answer: "All live sessions are recorded and available for replay within 24 hours. We also offer flexible scheduling with multiple time zones accommodated. However, we recommend attending live when possible for the best interactive learning and networking experience."
    },
    {
      question: "What happens after the 12 months?",
      answer: "You'll graduate with your international certification, a running business, established authority in your niche, and access to our lifetime alumni community. We also offer advanced mastermind programs, speaking opportunities, and partnership possibilities for continued growth."
    },
    {
      question: "How competitive is the scholarship program?",
      answer: "The 40% scholarship is merit-based and available to qualifying candidates who demonstrate exceptional commitment and potential. Approximately 40-50% of admitted students receive scholarship support. We evaluate applications on a rolling basis, so early application is recommended."
    },
    {
      question: "Can I pursue this while working full-time?",
      answer: "Absolutely. The program is designed for working professionals with flexible learning modules, recorded sessions, and asynchronous content. Most students dedicate 10-15 hours per week. We recommend clearing your schedule more in months 10-12 for final certification requirements."
    }
  ],

  timeline: {
    applicationDeadline: "Rolling admissions until seats are filled",
    nextCohortStart: "February 1, 2026",
    programDuration: "12 months",
    selectionProcess: "2-3 weeks from application"
  }
};

export const applicationSteps = [
  {
    step: 1,
    title: "Basic Information",
    fields: ["fullName", "email", "phone", "location"]
  },
  {
    step: 2,
    title: "Background & Experience",
    fields: ["currentProfession", "wellnessExperience", "education", "whyWellness"]
  },
  {
    step: 3,
    title: "Goals & Commitment",
    fields: ["careerGoals", "incomeGoals", "timeCommitment", "investmentReady"]
  }
];

// Form submission handler (real API)
export const submitApplication = async (formData) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const API = `${BACKEND_URL}/api`;
  
  try {
    const response = await fetch(`${API}/applications`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to submit application');
    }
    
    const data = await response.json();
    
    return {
      success: true,
      message: data.message,
      applicationId: data.applicationId
    };
    
  } catch (error) {
    console.error('Application submission error:', error);
    throw error;
  }
};
